 
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetBankService {

  constructor(private http: HttpClient) {}

  async GetBank() {
    try { 
      let response = await this.http
        .get(`${appApiResources.getBank}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}